const nav = {
    aiScheduler: 'AI Scheduler (App Demo)',
    fileUpload: 'Upload File (AWS S3)',
    documentation: 'Documentation',
    blog: 'Blog',
    login: 'LOGIN',
    logout: 'LOGOUT',
    home: 'HOME',
    trips: 'TRIPS',
    products: 'Products',
    cart: 'CART',
    aboutUs: 'ABOUT US',
    myAccount: 'MY ACCOUNT',
    signUp: 'SIGN UP',
    contacts: 'CONTACTS'
};

export default nav;
